import React from 'react';
import Remarkable from 'remarkable';
import './index.scss';
import Checkbox from '../checkbox';
import store from '../../../helpers/store';
import * as MainActions from '../../main/actions';
import { LAYERS } from '../../layers/types';

export default class Consent extends React.Component {
    constructor(props) {
        super(props);

        const consentIds = this.getConsentIds(this.props.consentId, this.props.informationId);
        this.state = {
            isInfoVisible: false,
            consentId: consentIds.consent,
            informationId: consentIds.information
        };
    }

    getConsentIds(consentId, informationId) {
        const state = store.getState();
        const getKeys = (configKey, defaultKey) => {
            if (configKey && state.settings.literals && state.settings.literals[configKey]) {
                return configKey;
            } else {
                return defaultKey;
            }
        };
        const consentIdKey = getKeys(consentId, 'consent');
        const informationIdKey = getKeys(informationId, 'information');
        return {
            consent: consentIdKey,
            information: informationIdKey
        };
    }

    onChange(isChecked) {
        if (this.props.onChange) {
            this.props.onChange({
                isChecked: isChecked,
                consentId: this.state.consentId,
                informationId: this.state.informationId
            });
        }
    }

    toggleInfo() {
        this.setState(prev => ({
            isInfoVisible: prev.isInfoVisible ? false : true
        }));
    }

    launchRevokeCMBView() {
        MainActions.onOpen({
            config: {
                defaultView: 'cmbRevokePopup',
                cmbrevokeOptions: {}
            }
        });
        MainActions.onClose({
            layer: LAYERS.WIDGET
        });
    }

    getLiteral(literal) {
        const state = store.getState();

        if (state.settings.literals && state.settings.literals[literal]) {
            return state.settings.literals[literal];
        } else if (literal === 'consent') {
            return 'Udzielam zgody na przetwarzanie przez Orange Polska S.A. numeru telefonu poprzez <span style="color:#ff7000; font-weight: bold">jednorazowy kontakt telefoniczny</span> w celu marketingu bezpośredniego swoich produktów lub usług.';
        } else if (literal === 'information') {
            return 'Administratorem danych przetwarzanych w związku z pozostawieniem danych do kontaktu w serwisie internetowym Orange Polska jest Orange Polska S.A. z siedzibą w Warszawie, pod adresem Aleje Jerozolimskie 160, 02-326 Warszawa (dalej Orange Polska). Dane kontaktowe administratora danych: Orange Polska S.A., ul. Jagiellońska 34, 96-100 Skierniewice. Dane kontaktowe inspektora ochrony danych w Orange Polska: inspektorochronydanych@orange.com.\nPrzekazany nam numer telefonu zostanie wykorzystany do:\n- jednorazowego skontaktowania się w celu przedstawienia oferty naszych produktów lub usług (podstawą prawną przetwarzania danych jest udzielona zgoda),\n- przesłania wiadomości sms potwierdzającej wpłyniecie zgłoszenia z prośbą o kontakt (podstawą prawną przetwarzania jest  realizacja prawnie uzasadnionego interesu Orange Polska),\n- dochodzenia i obrony przed roszczeniami (podstawą prawą przetwarzania danych jest realizacja prawnie uzasadnionego interesu Orange Polska).\n\nPodanie numeru telefonu nie jest wymogiem ustawowym lub umownym, ani warunkiem zawarcia jakiejkolwiek umowy, jednakże jest wymagane, jeśli chcą Państwo, abyśmy się z Państwem skontaktowali i przedstawili naszą ofertę.\nDodatkowo przetwarzamy również numer identyfikacyjny formularza oraz url formularza, w którym podali Państwo swój numer telefonu, co jest konsekwencją technicznego działania serwisu internetowego Orange Polska.\nPaństwa dane będą przekazywane podmiotom, które w ramach umów agencyjnych wykonują w imieniu i na zlecenie Orange Polska czynności polegające na wykonaniu kontaktu telefonicznego i umówieniu wizyty.\nDane będziemy przetwarzać przez okres niezbędny do zrealizowania zamówionego kontaktu oraz w okresie niezbędnym dla dochodzenia i obrony przed roszczeniami.\nPrzysługuje Państwu prawo do:\n- cofnięcia zgody w dowolnym momencie; przy czym cofnięcie zgody nie będzie miało wpływu na zgodność z prawem przetwarzania danych na podstawie zgody w okresie przed jej cofnięciem,\n- żądania dostępu do Państwa danych przetwarzanych przez Orange Polska,\n- sprostowania (poprawiania) danych,\n- usunięcia danych lub ograniczenia ich przetwarzania,\n- wniesienia sprzeciwu wobec przetwarzania danych,\n- przeniesienia danych, co oznacza prawo do otrzymania danych przetwarzanych przez Orange Polska lub żądanie ich przeniesienia do innego podmiotu.\n\nRealizacja przez nas tych praw uzależniona jest od możliwości zidentyfikowania osoby występującej z żądaniem, aby mieć pewność, że zostało ono złożone przez osobę do tego  uprawnioną.\nZakres każdego z praw oraz sytuacje, w których można z nich skorzystać, wynikają z przepisów prawa. To, z którego uprawnienia możecie Państwo skorzystać, zależeć będzie np. od podstawy prawnej oraz celu przetwarzania danych.\nZ tych praw możecie Państwo skorzystać składając wniosek w salonie Orange lub dzwoniąc pod numer naszej infolinii (numer dostępny jest na www.orange.pl/kontakt).\nJeśli uznacie Państwo, że Orange Polska przetwarza Państwa dane niezgodnie z prawem możecie wnieść skargę do Prezesa Urzędu Ochrony Danych Osobowych.';
        }
    }

    render() {
        const consentText = this.getLiteral(this.state.consentId);
        const informationText = this.getLiteral(this.state.informationId);
        const md = new Remarkable('full', {
            html: true,
            xhtmlOut: false,
            breaks: true,
            langPrefix: 'md-',
            linkify: true,
            typographer: true,
            quotes: '„”\'\'',
            linkTarget: '_blank'
        });
        return (
            <div className="consent">
                <Checkbox
                    isChecked={this.props.isChecked}
                    onChange={isChecked => this.onChange(isChecked)}
                    clickableText={
                        <div
                            className="consent--text"
                            dangerouslySetInnerHTML={{
                                __html: md.render(consentText)
                            }}
                        />
                    }
                    text={
                        <div className="consent--infoText">
                            <div className="header">
                                <p className="link">
                                    <a href="#" onClick={() => this.toggleInfo()}>
                                        Obowiązek informacyjny
                                    </a>
                                </p>
                            </div>
                            {this.state.isInfoVisible ? (
                                <div
                                    className="content"
                                    dangerouslySetInnerHTML={{
                                        __html: md.render(informationText)
                                    }}
                                />
                            ) : null}
                            <div className="cmbRevoke">
                                <p>Udzieloną wcześniej zgodę możesz odwołać:</p>
                                <p className="link">
                                    <a href="#" onClick={() => this.launchRevokeCMBView()}>
                                        Odwołaj zgodę na kontakt telefoniczny
                                    </a>
                                </p>
                            </div>
                        </div>
                    }
                />
            </div>
        );
    }
}
